<div
  style="
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  "
>
  <div>
    <div
      *ngIf="formControl.value as desc"
      style="display: flex; align-items: center"
    >
      <p style="margin-top: 0; margin-right: 10px">Name: {{ desc.name }}</p>
      <a
        class="button-ghost"
        [routerLink]="['/extensions', 'mandatory-product-notices', desc.id]"
        target="_blank"
      >
      {{ "common.details" | translate }}
        <clr-icon shape="link"></clr-icon>
      </a>
    </div>
  </div>
</div>

<ng-select
  [items]="descriptions$ | async"
  appendTo="body"
  bindLabel="name"
  [addTag]="false"
  [multiple]="false"
  [hideSelected]="true"
  [trackByFn]="trackByFn"
  [minTermLength]="0"
  [loading]="isLoading"
  [typeahead]="input$"
  [formControl]="formControl"
>
  <ng-template ng-label-tmp let-item="item" let-clear="clear">
    <span class="item-row">
      <clr-icon shape="user" class="is-solid"></clr-icon
      ><span class="mx-1">{{ item.name }}</span>
    </span>
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    <span class="item-row">
      <clr-icon shape="user" class="is-solid"></clr-icon
      ><span class="mx-1">{{ item.name }}</span>
    </span>
  </ng-template>
</ng-select>
